import { render, staticRenderFns } from "./PaymentInstructionPropertyListItem.vue?vue&type=template&id=3b8c5b63&scoped=true&"
import script from "./PaymentInstructionPropertyListItem.vue?vue&type=script&lang=ts&"
export * from "./PaymentInstructionPropertyListItem.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentInstructionPropertyListItem.vue?vue&type=style&index=0&id=3b8c5b63&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c5b63",
  null
  
)

export default component.exports